import React, { useEffect, useState } from 'react';
import { Col } from 'reactstrap';
import { Row } from 'react-bootstrap';
import { dateFormat, phoneFormat, convertToCamelCase } from '../shared/util';

const GenericCertificateCoverage = ({ assetDetails, styles, cocTranslation }) => {
    const currencyFormat = (val) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(val);
    const addonData = assetDetails?.assetDetails.filter((asset) => asset?.pricingLevelType === 'Addon');

    const getCountryTranslation = (country) => {
        if (country?.toLowerCase() === 'canada') {
            return cocTranslation?.cocContent?.canada || country;
        } else if (country?.toLowerCase() === 'united states') {
            return cocTranslation?.cocContent?.unitedStates || country;
        }
    };

    const getTermTranslation = (term) => {
        switch (term) {
            case 'One Year':
                return cocTranslation?.cocContent?.oneYear || term;
            case 'Two Year':
                return cocTranslation?.cocContent?.twoYear || term;
            case 'Three Year':
                return cocTranslation?.cocContent?.threeYear || term;
            case 'Four Year':
                return cocTranslation?.cocContent?.fourYear || term;
            case 'Five Year':
                return cocTranslation?.cocContent?.fiveYear || term;
            case 'Six Year':
                return cocTranslation?.cocContent?.sixYear || term;
            case 'Seven Year':
                return cocTranslation?.cocContent?.sevenYear || term;
            case 'Eight Year':
                return cocTranslation?.cocContent?.eightYear || term;
            case 'Nine Year':
                return cocTranslation?.cocContent?.nineYear || term;
            case 'Ten Year':
                return cocTranslation?.cocContent?.tenYear || term;
            case 'Twelve Year':
                return cocTranslation?.cocContent?.twelveYear || term;
            case 'Fifteen Year':
                return cocTranslation?.cocContent?.fifteenYear || term;
            case 'Monthly':
                return cocTranslation?.cocContent?.monthly || term;
            case 'Quarterly':
                return cocTranslation?.cocContent?.quarterly || term;
            case 'Annual':
                return cocTranslation?.cocContent?.annual || term;
            default:
                return term;
        }
    };

    const footerContent = () => {
        const baseServiceContact = cocTranslation?.cocContent?.serviceContact || '';
        const { certificateTypeName, certificateName, dealerPhone, servicePhone, serviceWebsite } = assetDetails || {};

        const handlers = {
            HVAC: () => baseServiceContact.replace('%CustomerServicePhone_content%', phoneFormat(dealerPhone)),
            HomeServices: () =>
                baseServiceContact
                    .replace('%ServicePhone%', phoneFormat(servicePhone))
                    .replace('%ServiceWebsite%', serviceWebsite || '')
        };
        return handlers[certificateTypeName]?.() || handlers[certificateName]?.() || baseServiceContact;
    };

    return (
        <>
            <Row className='m-0 mt-4'>
                <Col
                    className='pl-0'
                    lg='12'
                    md='12'
                >
                    <div className='mb-0'>
                        <img
                            id='logo-image'
                            tabIndex={0}
                            width={cocTranslation?.headerContent?.COCLogoWidth_style}
                            src={
                                assetDetails?.accountName
                                    ? `/document/GetCertificateLogo/${assetDetails?.programId}`
                                    : cocTranslation?.headerContent?.COCLogoURL_style
                            }
                        />
                    </div>
                </Col>
                <Col className='p-0'>
                    <p className='mb-0 mt-3'>650 Missouri Avenue</p>
                    <p className='mb-0'>Jeffersonville, IN 47130</p>
                </Col>
            </Row>
            <Row className='d-block mt-4'>
                <h4 className='text-center text-uppercase'>
                    {cocTranslation?.cocContent?.certificateTitle || 'ORDER CONFIRMATION'}
                </h4>
            </Row>
            <Row className={`m-0 mb-4 ${styles.addressContainer}`}>
                <Col className={`pl-0 ${styles.headerContainer} ${styles.addressDetail}`}>
                    <div className='mb-2'>
                        <span className={styles.userHeading}>
                            {cocTranslation?.cocContent?.sellerHeading || 'Seller'}
                        </span>
                    </div>
                    <div>{assetDetails?.dealerName}</div>
                    <div>{assetDetails?.dealerAddress1}</div>
                    {assetDetails?.dealerAddress2 && <div> {assetDetails?.dealerAddress2}</div>}
                    <div>
                        {`${assetDetails?.dealerCity}, ${assetDetails?.dealerStateAbbreviation} ${assetDetails.dealerZip}`}{' '}
                    </div>
                    <div>{getCountryTranslation(assetDetails?.dealerCountryName)}</div>
                </Col>
                <Col className={styles.addressDetail}>
                    <div className='mb-2'>
                        <span className={styles.userHeading}>
                            {cocTranslation?.cocContent?.issuedHeading || 'Issued To'}
                        </span>
                    </div>
                    <div>{assetDetails?.customerCompanyName}</div>
                    <div>{assetDetails?.customerName}</div>
                    <div>{assetDetails?.customerAddress1}</div>
                    {assetDetails?.customerAddress2 && <div> {assetDetails?.customerAddress2}</div>}
                    <div>
                        {`${assetDetails?.customerCity}, ${assetDetails?.customerStateAbbreviation} ${assetDetails.customerZip}`}{' '}
                    </div>
                    <div>{getCountryTranslation(assetDetails?.customerCountryName)}</div>
                </Col>
            </Row>
            <Row>
                <Col className='md-12 lg-12 mb-4'>
                    <div className={styles.introWrapper}>
                        {cocTranslation?.cocContent?.introParagraph
                            || `This Plan provides protection for the Covered Products. The enclosed terms and conditions
                            provide details regarding coverage.`}
                    </div>
                    {cocTranslation?.cocContent?.introParagraphSecondary && (
                        <div className='mt-3'>{cocTranslation?.cocContent?.introParagraphSecondary}</div>
                    )}
                </Col>
            </Row>
            {/* PLAN INFORMATION content */}
            <Row className='mb-4'>
                <Col className='md-12 lg-12'>
                    <div className={styles.planInformation}>
                        <h6>{cocTranslation?.cocContent?.planInfoHeading || 'PLAN INFORMATION:'}</h6>
                        {cocTranslation?.cocContent?.planNum && (
                            <p>
                                <span className='pr-1'>{cocTranslation?.cocContent?.planNum}</span>
                                {assetDetails?.contractNumber}
                            </p>
                        )}
                        {cocTranslation?.cocContent?.OrderNum_content && (
                            <p>
                                <span className='pr-1'>{cocTranslation?.cocContent?.OrderNum_content}</span>
                                {assetDetails?.clientContractNumber}
                            </p>
                        )}
                        {cocTranslation?.cocContent?.retailPrice && (
                            <p>
                                <span className='pr-1'>{cocTranslation?.cocContent?.retailPrice}</span>
                                {assetDetails?.certificateTypeName !== 'HVAC'
                                    ? currencyFormat(assetDetails?.planTotal)
                                    : assetDetails?.retailPrice
                                      ? currencyFormat(assetDetails?.retailPrice)
                                      : cocTranslation?.cocContent?.retailPriceAmt}
                            </p>
                        )}
                        {cocTranslation?.cocContent?.renewalFee && (
                            <p>
                                <span className='pr-1'>{cocTranslation?.cocContent?.renewalFee}</span>
                                {currencyFormat(assetDetails?.renewalAmt)}
                            </p>
                        )}
                        {cocTranslation?.cocContent?.serviceFee && (
                            <p>
                                <span className='pr-1'>{cocTranslation?.cocContent?.serviceFee}</span>
                                {assetDetails?.serviceFee === null || assetDetails?.serviceFee === '0'
                                    ? cocTranslation?.cocContent?.notApplicable || 'Not Applicable'
                                    : currencyFormat(assetDetails?.serviceFee)}
                            </p>
                        )}
                        {cocTranslation?.cocContent?.planBundle && (
                            <p>
                                <span className='pr-1'>{cocTranslation?.cocContent?.planBundle}</span>
                                {assetDetails?.planName}
                            </p>
                        )}
                        {assetDetails?.certificateTypeName !== 'HVAC'
                            && cocTranslation?.cocContent?.coveredProducts && (
                                <p>
                                    <span className='pr-1'>{cocTranslation?.cocContent?.coveredProducts}</span>
                                    {cocTranslation?.cocContent?.coveredProductsHeading}
                                </p>
                            )}
                        {assetDetails?.assetDetails?.length
                            && assetDetails?.certificateTypeName !== 'HVAC'
                            && assetDetails?.certificateName !== 'HomeServices'
                            && assetDetails?.certificateTypeName !== 'Standard Addon' && (
                                <ul>
                                    {assetDetails?.assetDetails?.map((asset) => {
                                        return (
                                            <li>
                                                {asset?.brandName?.toLowerCase() !== 'unknown' && asset.brandName}{' '}
                                                {asset.assetName}{' '}
                                                {asset.modelNumber && <span>Model: {asset.modelNumber}</span>}{' '}
                                                {asset.serialNumber && <span>Serial: {asset.serialNumber}</span>}
                                            </li>
                                        );
                                    })}
                                </ul>
                            )}
                    </div>
                </Col>
            </Row>
            {/* PLAN TERM content */}
            <Row className='mb-4'>
                <Col className='md-12 lg-12'>
                    <div className={styles.planInformation}>
                        <h6>{cocTranslation?.cocContent?.planTerm || 'PLAN TERM:'}</h6>
                        {cocTranslation?.cocContent?.purchaseDate && (
                            <p>
                                <span className='pr-1'>{cocTranslation?.cocContent?.purchaseDate}</span>
                                {assetDetails?.purchaseDate === null
                                    ? 'Not Available'
                                    : dateFormat(assetDetails?.purchaseDate, assetDetails?.customerCountryId)}
                            </p>
                        )}
                        {cocTranslation?.cocContent?.term && (
                            <p>
                                <span>{cocTranslation?.cocContent?.term}</span> {getTermTranslation(assetDetails?.term)}
                            </p>
                        )}
                        {cocTranslation?.cocContent?.InstallDate_content && (
                            <p>
                                <span className='pr-1'>{cocTranslation?.cocContent?.InstallDate_content}</span>
                                {assetDetails?.installDate === null
                                    ? 'Not Available'
                                    : dateFormat(assetDetails?.installDate, assetDetails?.customerCountryId)}
                            </p>
                        )}
                        {cocTranslation?.cocContent?.waitPeriod && (
                            <p>
                                <span>{cocTranslation?.cocContent?.waitPeriod}</span> {assetDetails?.waitPeriod}{' '}
                                {cocTranslation?.cocContent?.days || 'days'}
                            </p>
                        )}
                        {cocTranslation?.cocContent?.termRenewal && (
                            <p>
                                <span>{cocTranslation?.cocContent?.termRenewal}</span> {assetDetails?.renewalTerm}
                            </p>
                        )}
                        {cocTranslation?.cocContent?.effectiveDate && (
                            <p>
                                <span className='pr-1'>{cocTranslation?.cocContent?.effectiveDate}</span>
                                {assetDetails?.coverageStart === null
                                    ? 'Not Available'
                                    : dateFormat(assetDetails?.enforceDate, assetDetails?.customerCountryId)}
                            </p>
                        )}
                        {cocTranslation?.cocContent?.expDate && (
                            <p>
                                <span className='pr-1'>{cocTranslation?.cocContent?.expDate}</span>
                                {assetDetails?.coverageEnd === null
                                    ? 'Not Available'
                                    : dateFormat(assetDetails?.endDate, assetDetails?.customerCountryId)}
                            </p>
                        )}
                    </div>
                </Col>
            </Row>
            {/* Coverage Types content for NON HVAC */}
            {assetDetails?.certificateTypeName !== 'HVAC'
                && (cocTranslation?.cocContent?.coverageType1
                    || cocTranslation?.cocContent?.coverageType2
                    || cocTranslation?.cocContent?.coverageType3
                    || cocTranslation?.cocContent?.coverageType4
                    || cocTranslation?.cocContent?.coverageType5) && (
                    <Row className='mb-4'>
                        <Col className='md-12 lg-12'>
                            <div className={styles.planInformation}>
                                <h6>{cocTranslation?.cocContent?.typeOfCoverage || 'COVERED BREAKDOWNS:'}</h6>
                                <p>
                                    <span>{cocTranslation?.cocContent?.coverageType1}</span> {assetDetails?.coverage1}
                                </p>
                                <p>
                                    <span>{cocTranslation?.cocContent?.coverageType2}</span> {assetDetails?.coverage2}
                                </p>
                                <p>
                                    <span>{cocTranslation?.cocContent?.coverageType3}</span> {assetDetails?.coverage3}
                                </p>
                                <p>
                                    <span>{cocTranslation?.cocContent?.coverageType4}</span> {assetDetails?.coverage4}
                                </p>
                                <p>
                                    <span>{cocTranslation?.cocContent?.coverageType5}</span> {assetDetails?.coverage4}
                                </p>
                            </div>
                        </Col>
                    </Row>
                )}
            {/* Coverage Types content for HVAC */}
            {assetDetails?.certificateTypeName === 'HVAC' && (
                <Row className='mb-4'>
                    <Col className='md-12 lg-12'>
                        <div className={styles.planInformation}>
                            <h6>{cocTranslation?.cocContent?.typeOfCoverage || 'TYPE OF SERVICE:'}</h6>
                            <p>
                                <span className='pr-1'>{cocTranslation?.cocContent?.coverage || 'Coverage:'}</span>
                                {cocTranslation?.coverageDetail?.[convertToCamelCase(assetDetails?.coverageType)]
                                    || assetDetails?.coverageType}
                            </p>
                        </div>
                    </Col>
                </Row>
            )}
            {/* Technical Coverage content */}
            {(cocTranslation?.cocContent?.technicalCoverage1
                || cocTranslation?.cocContent?.technicalCoverage2
                || cocTranslation?.cocContent?.technicalCoverage3
                || cocTranslation?.cocContent?.technicalCoverage4) && (
                <Row>
                    <Col className='md-12 lg-12'>
                        <div className={styles.planInformation}>
                            <h6>{cocTranslation?.cocContent?.techincalCoverage || 'Technical Coverages:'}</h6>
                            <p>
                                <span>{cocTranslation?.cocContent?.technicalCoverage1}</span>{' '}
                                {assetDetails?.technicalSupportCoverage1}
                            </p>
                            <p>
                                <span>{cocTranslation?.cocContent?.technicalCoverage2}</span>{' '}
                                {assetDetails?.technicalSupportCoverage2}
                            </p>
                            <p>
                                <span>{cocTranslation?.cocContent?.technicalCoverage3}</span>{' '}
                                {assetDetails?.technicalSupportCoverage3}
                            </p>
                            <p>
                                <span>{cocTranslation?.cocContent?.technicalCoverage4}</span>{' '}
                                {assetDetails?.technicalSupportCoverage4}
                            </p>
                        </div>
                    </Col>
                </Row>
            )}
            {/* Covered Products content only for HVAC */}
            {assetDetails?.certificateTypeName === 'HVAC' && (
                <Row>
                    <Col className='md-12 lg-12'>
                        <div className={styles.planInformation}>
                            <h6>{cocTranslation?.cocContent?.coveredProducts || 'COVERED PRODUCTS:'}</h6>
                            <ul className='mt-2'>
                                {assetDetails?.assetDetails?.map((asset) => {
                                    return (
                                        <li>
                                            {asset?.brandName?.toLowerCase() !== 'unknown' && asset.brandName}{' '}
                                            {cocTranslation?.assetDetails?.[convertToCamelCase(asset.assetName)]
                                                || asset.assetName}
                                            {asset.modelNumber && (
                                                <span className='pl-1'>
                                                    <strong className='pr-1'>
                                                        {cocTranslation?.cocContent?.modelNumber || 'Model:'}
                                                    </strong>
                                                    {asset.modelNumber}
                                                </span>
                                            )}
                                            {asset.serialNumber && (
                                                <span className='pl-1'>
                                                    <strong className='pr-1'>
                                                        {cocTranslation?.cocContent?.serialNumber || 'Serial:'}
                                                    </strong>
                                                    {asset.serialNumber}
                                                </span>
                                            )}
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </Col>
                </Row>
            )}

            {/* ADD on Section for Homekick */}
            {assetDetails?.certificateTypeName === 'Standard Addon' && (
                <Row>
                    <Col className='md-12 lg-12'>
                        <div className={styles.planInformation}>
                            <h6>{cocTranslation?.cocContent?.addOnProducts || 'ADD-ON PRODUCTS:'}</h6>
                            {addonData.length > 0 ? (
                                <ul className='mt-2'>
                                    {addonData?.map((asset) => {
                                        return (
                                            <li>
                                                {asset?.brandName?.toLowerCase() !== 'unknown' && asset.brandName}{' '}
                                                {cocTranslation?.assetDetails?.[convertToCamelCase(asset.assetName)]
                                                    || asset.assetName}
                                                {asset.startDate && (
                                                    <span className='pl-1'>
                                                        <strong className='pr-1'>
                                                            {cocTranslation?.cocContent?.purchaseDate
                                                                || 'Purchase Date:'}
                                                        </strong>
                                                        {dateFormat(asset.startDate)}
                                                    </span>
                                                )}
                                                {asset.expirationDate && (
                                                    <span className='pl-1'>
                                                        <strong className='pr-1'>
                                                            {cocTranslation?.cocContent?.effectiveDate || 'Serial:'}
                                                        </strong>
                                                        {dateFormat(asset.expirationDate)}
                                                    </span>
                                                )}
                                            </li>
                                        );
                                    })}
                                </ul>
                            ) : (
                                <p>{'No add-on products have been added to this plan.'}</p>
                            )}
                        </div>
                    </Col>
                </Row>
            )}

            {cocTranslation?.cocContent?.noteParagraph && (
                <Row className='m-0 mt-3 '>
                    <p className='mb-0'>{cocTranslation?.cocContent?.noteParagraph}</p>
                </Row>
            )}
            {cocTranslation?.cocContent?.obligorParagraph && (
                <Row className='m-0 mt-3 '>
                    <p className='mb-0'>{cocTranslation?.cocContent?.obligorParagraph}</p>
                </Row>
            )}
            {cocTranslation?.cocContent?.adminParagraph && (
                <Row className='m-0 mt-3'>
                    <p className='mb-0'>{cocTranslation?.cocContent?.adminParagraph}</p>
                </Row>
            )}
            <Row className='m-0 mt-3'>
                <div className={styles.footerText}>{cocTranslation?.cocContent?.forService}</div>
                <div className={styles.footerText}>{footerContent()}</div>
            </Row>
        </>
    );
};

export default GenericCertificateCoverage;
